import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    withIonLifeCycle,
    IonItem,
    IonModal,
    IonIcon,
    IonButton,
    IonSegment,
    IonSegmentButton,
    IonLabel,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
    IonButtons, IonList, IonContent, IonHeader, IonMenu, IonMenuButton, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonDatetime, IonPopover, IonSearchbar,
    IonBackButton,
    IonToast
} from '@ionic/react';
import { closeOutline, person, print, barcode, warning, eye, search, funnel, create, business } from 'ionicons/icons';
import PosActions from '../../actions/PosActions';
import { getLoginApp } from '../../utils/functions';
import './Orders.css';
import Moment from 'react-moment';
import moment from 'moment';
import { DebounceInput } from 'react-debounce-input';
import { Printer } from '@bcyesil/capacitor-plugin-printer';

import {
    queryAllPermisions
} from "../../data_base_local/dataservice";
import { baseurl } from '../../constants/constants';
import { Capacitor } from '@capacitor/core';
import Select from 'react-select';
const options2 = { style: 'currency', currency: 'USD' };
const _numberFormat = new Intl.NumberFormat('en-US', options2);

interface IProps {
    get_: any;
    setData_: any;
}

interface IState {
    pageSize: any;
    pages: any;
    loadmore_data_pagination: any;
    current_count_data: any;
    total_rows: any;
    searchText: any;
    segmentActive: any;
    type_transaction: any;
    transactions: any;

    currencyprimary: any;
    primary_label: any;

    currencysecondary: any;
    secondary_label: any;
    secondary_operation: any;
    cash_register_util: any;
    datalogin: any;
    isOpenDateStart: any;
    DateStart: any;
    isOpenDateEnd: any;
    DateEnd: any;
    isOpenModalFilterDate: any;
    payment_types_key: any;
    rutas: any;
    ruta_ids: any;
    simpleToast: any;
    response: any;
}

class Orders extends React.Component<IProps, IState> {
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;
    contentRef: React.RefObject<HTMLIonContentElement>;

    constructor(props: any) {
        super(props)
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();
        this.contentRef = React.createRef<HTMLIonContentElement>();

        this.state = {
            segmentActive: props.segmentActive,

            loadmore_data_pagination: props.loadmore_data_pagination,
            current_count_data: props.current_count_data,
            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            pageSize: props.pageSize,
            type_transaction: props.type_transaction,
            transactions: props.transactions,

            currencyprimary: props.currencyprimary,
            primary_label: props.primary_label,
            currencysecondary: props.currencysecondary,
            secondary_label: props.secondary_label,
            secondary_operation: props.secondary_operation,
            cash_register_util: props.cash_register_util,
            isOpenDateStart: props.isOpenDateStart,
            DateStart: props.DateStart,
            datalogin: props.datalogin,
            isOpenDateEnd: props.isOpenDateEnd,
            DateEnd: props.DateEnd,
            isOpenModalFilterDate: props.isOpenModalFilterDate,
            payment_types_key: props.payment_types_key,
            rutas: props.rutas,
            ruta_ids: props.ruta_ids,
            simpleToast: props.simpleToast,
            response: props.response
        };
    }
    ionViewWillEnter() {
        console.log('ionViewWillEnter 1 Cart');
        this.componentDidMount();
    }
    async componentDidMount() {
        if (Capacitor.isNativePlatform()) {
            this.ValidatePermission();
        }
        this.props.get_({
            typeOption: 'get_data_default',
            user_id: getLoginApp().id,
        }, "api/get_data_default");

        this.setState({
            segmentActive: 1,
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            loadmore_data_pagination: true,
            type_transaction: 'suspend',
            transactions: [],
            datalogin: getLoginApp(),
            isOpenDateStart: false,
            DateStart: new Date().toISOString(),
            isOpenDateEnd: false,
            DateEnd: new Date().toISOString(),
            isOpenModalFilterDate: false,

        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    /*necesario para validar permisos*/
    async ValidatePermission() {

        let dataPermissions: any = await queryAllPermisions().then();
        let is_valid = true;
        if (dataPermissions && dataPermissions.values.length > 0) {
            dataPermissions.values.map((val: any, key: any) => {
                if (val.status !== 'active') {
                    is_valid = false;
                }
            });
        } else {
            is_valid = false;
        }

        if (!is_valid) {
            window.location.href = baseurl() + "/home";
        }
    };
    /* fin necesario para validar permisos*/

    getDataPaginInit() {
        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        if (this.state.segmentActive == 5) {
            this.props.get_({
                type_transaction: this.state.type_transaction,
                typeOption: 'getNotSellRutas',
                search: this.state.searchText,
                pageSize: this.state.pageSize,
                pages: this.state.pages,
                current_count_data: this.state.current_count_data,
                created_by: this.state.datalogin.id,
                start: moment(this.state.DateStart, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
                end: moment(this.state.DateEnd, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
                user_id: this.state.datalogin.id,
                view_active: 'orders_suspends'
            }, "api/getNotSellRutas");
        } else {
            this.props.get_({
                type_transaction: this.state.type_transaction,
                typeOption: 'getSellRutas',
                search: this.state.searchText,
                pageSize: this.state.pageSize,
                pages: this.state.pages,
                current_count_data: this.state.current_count_data,
                created_by: this.state.datalogin.id,
                start: moment(this.state.DateStart, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
                end: moment(this.state.DateEnd, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
                user_id: this.state.datalogin.id,
                view_all: true,
                view_active: 'orders_suspends',
                ruta_ids: this.state.ruta_ids
            }, "api/getSellRutas");
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            transactions: nextProps.data.data_pagin_transactions && nextProps.data.data_pagin_transactions ? nextProps.data.data_pagin_transactions : [],
            pages: nextProps.data.transactions && nextProps.data.transactions.pages ? nextProps.data.transactions.pages : 0,
            total_rows: nextProps.data.transactions && nextProps.data.transactions.total_rows ? nextProps.data.transactions.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_transactions ? nextProps.data.data_pagin_transactions.length : 0,
            loadmore_data_pagination: true,

            cash_register_util: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util : null,
            currencyprimary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencyprimary : '',
            primary_label: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.primary_label : 'primary',
            currencysecondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencysecondary : '',
            secondary_label: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.secondary_label : 'secondary',
            payment_types_key: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.payment_types_key : [],

            rutas: nextProps.data.data_default && nextProps.data.data_default.rutas ? nextProps.data.data_default.rutas : [],
            simpleToast: nextProps.data.simpleToast,
            response: nextProps.data.response,
        });

        console.log(nextProps.data);
        if (nextProps.data.view_active == "orders_suspends") {

            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

        if (nextProps.data.response && nextProps.data.response.success && nextProps.data.response.receipt) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            setTimeout(this.printTransaction.bind(this, nextProps.data.response.receipt), 100);
        }
    }

    changeSegmet(segmentActive: any) {
        //final, quotation, draft, suspend,
        let type_transaction = "final";
        if (segmentActive == 1) {
            type_transaction = "final";
        } else if (segmentActive == 2) {
            type_transaction = "quotation";
        } else if (segmentActive == 3) {
            type_transaction = "draft";
        } else if (segmentActive == 4) {
            type_transaction = "suspend";
        } else if (segmentActive == 5) {
            type_transaction = "no_sell";
        }

        this.setState({
            segmentActive: segmentActive,
            type_transaction: type_transaction,
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            loadmore_data_pagination: true,
            transactions: []
        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }
    closemodalTransaction(row: any, index: any) {
        let transactions = this.state.transactions;

        const newArr = transactions.map((item: any, i: any) => {
            if ((index) == i) {
                return {
                    ...item,
                    'modalOpen': false
                };
            } else {
                return item;
            }
        });

        this.setState({
            transactions: newArr
        });
    }
    setActionTransactionModalShow(row: any, index: any) {
        let transactions = this.state.transactions;

        const newArr = transactions.map((item: any, i: any) => {
            if ((index) == i) {
                return {
                    ...item,
                    'modalOpen': true
                };
            } else {
                return item;
            }
        });

        this.setState({
            transactions: newArr
        });
    }
    render_transactions(row: any, key: any) {
        let currencyprimary = this.state.currencyprimary;
        let status = "Pagada";
        let status_color = "success";

        if (row.payment_status == 'paid') {
            status = "Pagada";
            status_color = "success";
        } else if (row.payment_status == "suspend") {
            status = "Suspendida";
            status_color = "error";
        } else if (row.payment_status == "due") {
            status = "Al Credito";
            status_color = "warning";
        } else if (row.payment_status == "partial") {
            status = "Parcial";
            status_color = "info";
        }

        if (row.sub_status == 'draft') {
            status = "Borrador";
        } else if (row.sub_status == 'quotation') {
            status = "Cotización";
        }
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12' className=''>
                        {row.sale_date_}
                        <br />
                        <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> #{row.invoice_no}</label>
                        <br />
                        <label className='text-sm font-medium text-g60'><IonIcon className='icon-vertical-aling' size='small' icon={person} />({row.contact_id}) {row.name}</label>
                        <br />
                        <label className='text-sm font-medium text-g60'><IonIcon className='icon-vertical-aling' size='small' icon={warning} />{status}</label> <br />
                        Total: <span >{row && row.final_total ? _numberFormat.format(row.final_total).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span><br />
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='default' color={'celeste'} onClick={() => this.setActionTransactionModalShow(row, key)}>
                            <IonIcon className='icon-vertical-aling' style={{ color: "white" }} size='small' icon={eye} />
                        </IonButton>
                        <IonButton size='default' color={'azul'} onClick={() => this.edit_transactions(row, key)}>
                            <IonIcon className='icon-vertical-aling' style={{ color: "white" }} size='small' icon={create} />
                        </IonButton>
                        <IonButton size='default' color={'tertiary'} onClick={() => this.sendprintTransaction(row)}>
                            <IonIcon className='icon-vertical-aling' style={{ color: "white" }} size='small' icon={print} />
                        </IonButton>
                    </IonCol>
                    <IonModal onWillDismiss={e => this.closemodalTransaction(row, key)} isOpen={row.modalOpen ?? false} trigger="open-modal" >
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>#{row.invoice_no}</IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.closemodalTransaction(row, key)}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonRow>
                                <IonCol col-12 size='12' key={key} className='card_line'>
                                    <IonRow>
                                        <IonCol col-12 size='12' style={{ textAlign: 'left' }} >
                                            <strong className=''>Cliente: {row.name}</strong><br />
                                            <strong className=''>Fecha: {row.sale_date_}</strong><br />
                                            <strong className=''>Estado: {status}</strong><br />
                                        </IonCol>
                                    </IonRow>
                                </IonCol>
                                {
                                    row.sell_lines.map((val_: any, key_: any) =>
                                        <IonCol col-12 size='12' key={key} className='card_line'>
                                            <IonRow>
                                                <IonCol col-12 size='12' style={{ textAlign: 'left' }} >
                                                    <strong className=''> {val_.product.name}</strong>   <br />
                                                    <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {val_.variations.sub_sku}</label>
                                                    {
                                                        val_.variations.name != 'DUMMY' ? <><br /> <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {val_.variations.name}</label></> : null
                                                    }
                                                </IonCol>
                                                <IonCol col-8 size='8' style={{ textAlign: 'left' }}>
                                                    Pr: {_numberFormat.format(parseFloat(val_.unit_price_inc_tax)).replace("$", "")} - Qty: {_numberFormat.format(parseFloat(val_.quantity)).replace("$", "")} <br /> St: {_numberFormat.format(parseFloat(val_.unit_price_inc_tax) * parseFloat(val_.quantity)).replace("$", "")}
                                                </IonCol>
                                            </IonRow>
                                        </IonCol>
                                    )
                                }
                                <div className='card_line'>
                                    <IonCol col-12 size='12'>
                                        <IonItem>
                                            <IonLabel>
                                                Sub-Total
                                            </IonLabel>
                                            <IonLabel slot='end' class='text-bold text-right'>
                                                <span >{row && row.total_before_tax ? _numberFormat.format(row.total_before_tax).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>
                                            </IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>
                                                Total Descuento (-)
                                            </IonLabel>
                                            <IonLabel slot='end' class='text-bold'>
                                                <span >{row && row.total_discount ? _numberFormat.format(row.total_discount).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>
                                            </IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>
                                                Impuestos (+)
                                            </IonLabel>
                                            <IonLabel slot='end' class='text-bold'>
                                                <span >{row && row.tax_amount ? _numberFormat.format(row.tax_amount).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>
                                            </IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>
                                                Total Neto
                                            </IonLabel>
                                            <IonLabel slot='end' class='text-bold'>
                                                <span >{row && row.final_total ? _numberFormat.format(row.final_total).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>
                                            </IonLabel>
                                        </IonItem>
                                    </IonCol>
                                </div>
                            </IonRow>
                        </IonContent>
                    </IonModal>
                </IonRow>
            </div>

        );
    }
    render_not_sell(row: any, key: any) {

        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12' className=''>
                        {row.sale_date_}
                        <br />
                        <label className='text-sm font-medium text-g60'><IonIcon className='icon-vertical-aling' size='small' icon={person} />({row.contact_id}) {row.name}</label>
                        <br />
                        <label className='text-sm font-medium text-g60'><IonIcon className='icon-vertical-aling' size='small' icon={business} />{row.supplier_business_name}</label>
                        <br />
                        <label className='text-sm font-medium text-g60'><IonIcon className='icon-vertical-aling' size='small' icon={warning} />{row.additional_notes}</label> <br />
                        Nota: {row.staff_note}
                    </IonCol>
                </IonRow>
            </div>

        );
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,
            loadmore_data_pagination: true
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    changeFilterDate(e: any) {

        let DateStart: any = null;
        let DateEnd: any = null;

        if (e.target.value == 'hoy') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'ayer') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
        } else if (e.target.value == 'ultimo_7') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(6, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'este_mes') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('month').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('month').format("YYYY-MM-DD");
        } else if (e.target.value == 'este_ano') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        } else if (e.target.value == 'ano_pasado') {
            DateStart = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        }

        this.setState({
            isOpenDateStart: false,
            DateStart: DateStart,
            isOpenDateEnd: false,
            DateEnd: DateEnd,
            isOpenModalFilterDate: false,
            pages: 0,
            pageSize: 10,
            loadmore_data_pagination: true
        });

        setTimeout(this.getDataPaginInit.bind(this), 100);
    }
    edit_transactions(row: any, key: any) {
        let products: any = [];
        let contact: any = {};

        contact.name = row.name;
        contact.mobile = row.mobile;
        contact.contact_id = row.contact_id;
        contact.supplier_business_name = row.supplier_business_name;
        contact.id = row.id_cont;

        row.sell_lines.map((val_: any, key_: any) => {
            products.push(
                {
                    "transaction_sell_lines_id": val_.id,
                    "product_id": val_.product_id,
                    "name": val_.product.name,
                    "type": val_.product.type,
                    "quantity": val_.quantity,
                    "current_price": val_.unit_price_inc_tax,
                    "current_price_discount": val_.unit_price_inc_tax,
                    "discount_amount": val_.line_discount_amount,
                    "discount_type": val_.line_discount_type,
                    "enable_stock": val_.product.enable_stock,
                    "unit_id": val_.product.unit.id,
                    "product_image": val_.product.image,
                    "id": val_.variations.id,
                    "variation": val_.variations.name,
                    "qty_available": val_.qty_available,
                    "default_sell_price": val_.variations.default_sell_price,
                    "sub_sku": val_.variations.sub_sku,
                    "dpp_inc_tax": val_.unit_cost,
                    "sub_units": val_.sub_units,
                    "modalOpen": false
                }
            );
        });

        let transaction: any = {};

        transaction.transaction_id = row.id;
        transaction.invoice_no = row.invoice_no;
        transaction.transaction_date = row.transaction_date;

        let payments: any = [];
        let payment_types_key = this.state.payment_types_key;

        row.payment_lines.map((val_: any, key_: any) => {
            let is_custom = val_.method.split("custom_pay_");
            payments.push(
                {
                    amount: val_.amount,
                    id: val_.method,
                    label: payment_types_key[val_.method],
                    note: val_.note,
                    secondary: val_.secondary,
                    [is_custom.length > 1 ? 'transaction_no_' + is_custom[1] : 'transaction_no']: val_.transaction_no,
                    transaction_no: val_.transaction_no,
                    payment_id: val_.id,
                }
            );
        });

        //tax impuestos
        let data_transactiotaxdic = {
            discount_type: row.discount_type,
            discount_amount: row.discount_amount,
            tax_id: row.tax_id,
            tax_amount: row.tax_amount,
            tax_calculation_amount: 0,
        };
        window.localStorage.setItem('data_transactiotaxdic', JSON.stringify(data_transactiotaxdic));

        window.localStorage.setItem('ari_app_contact', JSON.stringify(contact));
        window.localStorage.setItem('ari_app_shoppingcart', JSON.stringify(products));
        window.localStorage.setItem('ari_app_transaction', JSON.stringify(transaction));
        window.localStorage.setItem('ari_app_transaction_payments', JSON.stringify(payments));

        window.location.href = baseurl() + "/dashboard_pos/cart";

        console.log(products, payments);
    }

    handleRefresh(event: any) {
        this.setState({
            pages: 0,
            pageSize: 10,
        });
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    printTransaction(html: any) {
        if (Capacitor.isNativePlatform()) {
            Printer.print({ content: html, name: 'lorem-filename', orientation: 'portrait' })
                .then((res: any) => {
                    console.log(res);
                    this.props.setData_({ response: {}, simpleToast: false });
                })
                .catch((err: any) => {
                    console.error(err);
                    this.props.setData_({ response: {}, simpleToast: false });
                });
        } else {
            // Para navegador web
            const printFrame = document.createElement('iframe');
            printFrame.style.position = 'fixed';
            printFrame.style.right = '0';
            printFrame.style.bottom = '0';
            printFrame.style.width = '0';
            printFrame.style.height = '0';
            printFrame.style.border = '0';
            printFrame.srcdoc = html;
            // Insertar el iframe en el div print-area en lugar de document.body
            const printArea = document.getElementById('print-area');
            if (printArea) {
                printArea.appendChild(printFrame);
            } else {
                document.body.appendChild(printFrame);
            }

            printFrame.onload = () => {
                printFrame.contentWindow?.focus();
                printFrame.contentWindow?.print();
                setTimeout(() => {
                    if (printFrame.parentNode === document.body) {
                        document.body.removeChild(printFrame);
                    } else if (printFrame.parentNode) {
                        printFrame.parentNode.removeChild(printFrame);
                    }
                }, 3000);
            };

            this.props.setData_({ response: {}, simpleToast: false });
        }
    }

    sendprintTransaction(row: any) {
        this.props.get_({
            typeOption: 'print_transaction',
            id: row.id,
            user_id: this.state.datalogin.id,
            view_active: 'orders_suspends'
        }, "api/print_transaction");
    }


    handleChangeDefault(event: any) {
        console.log(event);
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value,
            pages: 0,
            pageSize: 10
        });

        setTimeout(this.getDataPaginInit.bind(this), 100);

    }
    onDidDismissToast(e: any) {
        this.props.setData_({ response: {}, simpleToast: false });
    }
    render() {
        const { simpleToast, response, rutas, segmentActive, transactions, currencyprimary, isOpenDateStart, DateStart, DateEnd, isOpenDateEnd, searchText, isOpenModalFilterDate } = this.state;
        let data_render_transactions = [];
        if (transactions && transactions.length > 0) {
            data_render_transactions = [];
            data_render_transactions = transactions.map((val: any, key: any) =>
                val.notsell ?
                    this.render_not_sell(val, key) : this.render_transactions(val, key)
            );
        };
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonButtons slot="start">
                            <IonBackButton defaultHref="/home" text={""} />
                        </IonButtons>
                        <IonTitle>Transacciones</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen ref={this.contentRef} scrollEvents={true}>
                    <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
                        <IonRefresherContent></IonRefresherContent>
                    </IonRefresher>
                    {
                        response && response.Msg ? (
                            <IonToast
                                isOpen={!!simpleToast}
                                color={response && (response.success == 1 || response.success == true) ? 'success' : 'danger'}
                                position='top'
                                message={`${response && response.Msg ? response.Msg : ''}`}
                                duration={1500}
                                onDidDismiss={e => this.onDidDismissToast(e)}
                            />
                        ) : null
                    }

                    <IonRow>
                        <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                            <IonButton
                                expand="full"
                                onClick={(e: any) => {
                                    e.persist();
                                    this.setState({
                                        isOpenDateStart: true,
                                        pages: 0,
                                        pageSize: 10,
                                        loadmore_data_pagination: true
                                    });
                                }}
                            >
                                Inicio :
                                <Moment
                                    date={DateStart}
                                    format="DD-MM-YYYY"
                                />
                            </IonButton>
                            <IonPopover
                                isOpen={isOpenDateStart}
                                onDidDismiss={() =>
                                    this.setState({
                                        isOpenDateStart: false,
                                        pages: 0,
                                        pageSize: 10,
                                        loadmore_data_pagination: true
                                    })}
                            >
                                <IonDatetime
                                    presentation="date"
                                    value={moment(DateStart, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                    onIonChange={(e: any) => {
                                        this.setState({ DateStart: e.detail.value, isOpenDateEnd: false });
                                        setTimeout(this.getDataPaginInit.bind(this), 1000);
                                    }}
                                ></IonDatetime>
                            </IonPopover>
                        </IonCol>
                        <IonCol col-2 size='2' style={{ textAlign: "center" }}>
                            <IonButton color='primary' expand="full" onClick={(e: any) => {
                                e.persist();
                                this.setState({ isOpenModalFilterDate: true });
                            }}>
                                <IonIcon icon={funnel}></IonIcon>
                            </IonButton>
                            <IonPopover
                                isOpen={isOpenModalFilterDate}
                                onDidDismiss={() =>
                                    this.setState({ isOpenModalFilterDate: false })}
                            >
                                <IonList inset={true}>
                                    <IonItem
                                        onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'hoy' } })}
                                    >
                                        <IonLabel>Hoy</IonLabel>
                                    </IonItem>
                                    <IonItem
                                        onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ayer' } })}>
                                        <IonLabel>Ayer</IonLabel>
                                    </IonItem>
                                    <IonItem
                                        onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ultimo_7' } })}>
                                        <IonLabel>Los Ultimos 7 Dias</IonLabel>
                                    </IonItem>
                                    <IonItem
                                        onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_mes' } })}>
                                        <IonLabel>Este Mes</IonLabel>
                                    </IonItem>
                                    <IonItem
                                        onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_ano' } })}>
                                        <IonLabel>Este Año</IonLabel>
                                    </IonItem>
                                    <IonItem
                                        onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ano_pasado' } })}>
                                        <IonLabel>El Año Pasado</IonLabel>
                                    </IonItem>
                                </IonList>
                            </IonPopover>
                        </IonCol>
                        <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                            <IonButton
                                expand="full"
                                onClick={(e: any) => {
                                    e.persist();
                                    this.setState({ isOpenDateEnd: true });
                                }}
                            >
                                Fin :
                                <Moment
                                    date={DateEnd}
                                    format="DD-MM-YYYY"
                                />
                            </IonButton>
                            <IonPopover
                                isOpen={isOpenDateEnd}
                                onDidDismiss={() =>
                                    this.setState({ isOpenDateEnd: false })}
                            >
                                <IonDatetime
                                    presentation="date"
                                    value={moment(DateEnd, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                    onIonChange={(e: any) => {
                                        this.setState({ DateEnd: e.detail.value, isOpenDateEnd: false });
                                        setTimeout(this.getDataPaginInit.bind(this), 1000);
                                    }}

                                ></IonDatetime>
                            </IonPopover>
                        </IonCol>
                        <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                            <div style={{ display: "none" }}>
                                <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                            </div>

                        </IonCol>
                        <IonCol col-12 size='12' class='divflex'>
                            <IonIcon icon={search} className='iconseach'></IonIcon>

                            <DebounceInput
                                className='btn_search'
                                placeholder={'Buscar cliente por Factura/Cliente'}
                                minLength={2}
                                debounceTimeout={2000}
                                value={searchText}
                                onChange={e => this.setSearchText(e)} />
                        </IonCol>
                        <IonCol col-12 size='12'>
                            {
                                rutas && rutas && rutas.length > 0 ?
                                    <Select
                                        onChange={(e: any) => this.handleChangeDefault({ target: { name: 'ruta_ids', value: e } })}
                                        placeholder="Rutas"
                                        name='ruta_ids'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        isMulti={true}
                                        options={
                                            rutas.map((option: any) => (
                                                { label: option.name, value: option.id }
                                            ))
                                        }
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}

                                    /> : null
                            }
                        </IonCol>
                        {data_render_transactions}
                    </IonRow>
                    <IonInfiniteScroll
                        threshold="50px"
                        ref={this.ionInfiniteScrollRefData}
                        onIonInfinite={(event) => {
                            this.getDataPaginInit();
                        }}
                    >
                        <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </IonContent>
            </IonPage >
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Orders));
